(function () {
    const $ = require('jquery');
    const Gumshoe = require('gumshoejs');

    const SmoothScroll = require('smooth-scroll');
    require('./sticky-kit');

    var $el = $('[data-gumshoe-header]');
    if ($el.length == 0) {
        return;
    }

    $el.stick_in_parent();
    $el.css('z-index', 9999);

    var scroll = new SmoothScroll('a[href*="#"]', {
        offset: 40,
    });

    const gumshoe = new Gumshoe('[data-gumshoe] a', {
        navClass: 'is-active',
        contentClass: 'is-active',
        reflow: true,
        offset: function () {
            return 100 + document.querySelector('[data-gumshoe-header]').getBoundingClientRect().height;
        }
    });

}());
